(function (angular) {
    angular.module("app").service("KeepAliveService", ["$rootScope", "$http", "restUrlPublicPrefix", function ($rootScope, $http, restUrlPublicPrefix) {
        return {
            ping: function () {
                $http({ method: 'GET', url: restUrlPublicPrefix + 'login-check' });
                //todo handle false as result
            }
        };
    }]);
})(angular);